import React from "react";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

import { useExecutionPanelContext } from "../ExecutionPanelContext";
import Stack from "@mui/material/Stack";

export const ExecutionPanelTitle = () => {
  const { debugMode, setDebugMode, title } = useExecutionPanelContext();
  const theme = useTheme();

  const handleTitleClick = (event: React.MouseEvent) => {
    // Alt/option-click toggles debug mode.
    if (event.altKey) {
      event.preventDefault();
      setDebugMode(!debugMode);
    }
  };

  return (
    <Grid flexGrow={1}>
      <Stack
        onClick={handleTitleClick}
        direction="row"
        data-ig-ai-shine-group
        sx={{
          cursor: "pointer",
          userSelect: "none",
          alignItems: "center",
          fontWeight: "600",
          ...(debugMode && {
            color: theme.palette.primary.main,
          }),
        }}
      >
        {title}
        {debugMode && <span>&nbsp;(Debug)</span>}
      </Stack>
    </Grid>
  );
};
